import bell from "@assets/bt-global/img-bell.png";
import IconFactory from "@components/Icon/IconFactory";
import { IconTypeEnum } from "@components/Icon/utils/types";
import {
  BT_NEWSLETTERS,
  NEWSLETTER_TYPE,
} from "@components/Newsletter/types/Newsletter";
import NewsletterForm from "@features/newsletter/components/NewsletterForm";
import { cn } from "@util/helpers";

export type BTGlobalNewsletterProps = {
  /** The classname of the component. */
  className?: string;
};

/** BT Global Newsletter component to subscribe to global newsletter which is use in /global page */
const BTGlobalNewsletter = ({
  className,
}: BTGlobalNewsletterProps): React.ReactElement => {
  const BTGLOBAL_NEWSLETTER = BT_NEWSLETTERS.filter(
    (newsletter) => newsletter.type === NEWSLETTER_TYPE.BTGLOBAL
  );

  return (
    <div
      data-testid="bt-global-newsletter-component"
      className={cn(
        "-mx-3 mb-10 w-svw border border-gray-175 bg-gray-125 md:mx-0 md:w-full",
        className
      )}
    >
      <div className="flex flex-col items-center justify-between px-8 py-8 lg:flex-row lg:px-15">
        <div className="flex flex-col items-center justify-center gap-6 pb-6 text-center font-poppins text-lg font-medium lg:flex-row lg:pb-0 lg:pr-40 lg:text-left ">
          <div className="relative flex aspect-square h-[72px] items-center justify-center">
            <div
              className={cn(
                "bg-[radial-gradient(50%_50%_at_50%_50%,rgba(236,_228,_208,_0.60)_63.46%,rgba(236,_228,_208,_0.60)_77.4%)] blur-[7px]",
                "absolute h-full w-full rounded-full"
              )}
            />

            <img
              className="relative z-10"
              src={bell}
              width={72}
              height={72}
              alt="newsletter"
            />
          </div>

          <p>{BTGLOBAL_NEWSLETTER[0].description}</p>
        </div>

        <NewsletterForm
          className="group lg:min-w-[360px]"
          buttonClassName={cn(
            "bg-gray-850 px-5 py-2 flex items-center justify-center text-white hover:opacity-75 border-0 w-auto"
          )}
          formClassName={cn(
            "p-1 rounded-full border border-gray-175 group-hover:border-gray-850 group-hover:border"
          )}
          inputClassName={cn("rounded-full px-4 placeholder:text-gray-515")}
          newsletters={BTGLOBAL_NEWSLETTER}
          isBordered={false}
          placeholder="Your email"
          signUpButtonIcon={
            <IconFactory
              type={IconTypeEnum.rightArrow}
              className="text-white"
            />
          }
        />
      </div>
    </div>
  );
};

export default BTGlobalNewsletter;
